import { useCallback, useState } from 'react'

const usePresentationNavigation = ({ slideCount, initialSlide = 0 } = {}) => {
    const [currentSlide, setCurrentSlide] = useState(initialSlide)
    //
    const next = useCallback(() => {
        setCurrentSlide(s => (s + 1) % slideCount);
    }, [slideCount]);

    const prev = useCallback(() => {
        setCurrentSlide(s => (s === 0 ? slideCount - 1 : s - 1));
    }, [slideCount]);
    const goTo = useCallback((index) => setCurrentSlide(Math.max(0, Math.min(slideCount - 1, index))), [slideCount])

    return {
        currentSlide,
        next,
        prev,
        goTo,
        isFirst: currentSlide === 0,
        isLast: currentSlide === slideCount - 1,
        slideCount
    }
}

export default usePresentationNavigation
